<script setup lang="ts">
import type { CheckboxGroupValueType, CheckboxValueType } from 'element-plus';

interface OptionsParams {
  label: string;
  value: string;
}

interface Props {
  options?: OptionsParams[],
  label?: string,
  hint?: string,
  disabled?: boolean,
  required?: boolean,
  buttonClassName?: string,
  groupClassName?: string,
}
export interface  Emits {
  change: [value: CheckboxValueType[]]
};

const props = withDefaults(defineProps<Props>(), {
  options: () => [],
  label: '',
  hint: '',
  disabled: false,
  required: false,
  buttonClassName: '',
  groupClassName: '',
});
const emit = defineEmits<Emits>();

const modelValue = defineModel<CheckboxGroupValueType>();

function handleChange(value: CheckboxValueType[]) {
  emit('change', value);
}
</script>

<template>
  <div class="ui-checkbox-group t:space-y-8">
    <UiLabel
      v-if="label"
      :disabled="disabled"
      :label="label"
      :hint="hint"
      :required="required"
    />
    <ElCheckboxGroup
      v-model="modelValue"
      class="t:flex t:items-center t:space-x-16"
      :class="[groupClassName]"
      :disabled="disabled"
      @change="handleChange"
    >
      <slot name="checkbox">
        <UiCheckbox
          v-for="opt in options"
          :key="opt.value"
          is-group
          :value="opt.value"
          :label="opt.label"
          :class="[buttonClassName]"
        />
      </slot>
    </ElCheckboxGroup>
    <slot />
  </div>
</template>

<style lang="scss">
.ui-checkbox-group {
  //display: flex;
  //align-items: center;
}
</style>
